import { defineMessages } from "react-intl"

export const headerMessages = defineMessages({
	actionButton: {
		defaultMessage: "Actions",
		id: "vehicleDetails.header.actions",
	},
	copySuccess: {
		defaultMessage: "Copied Listinglink to clipboard.",
		id: "copyListingUrlToClipboard.success",
	},
	editImages: {
		defaultMessage: "Edit Images",
		id: "routes.editMedia",
	},
	firstRegistrationAbbrevated: {
		defaultMessage: "EZ",
		id: "vehicleDetails.header.firstRegistration.abbrevated",
	},
	saleDetailsPage: {
		defaultMessage: "Sale Details Page",
		id: "vehicleDetails.header.saleDetailsPage",
	},
})
